export const BUY_INSURANCE_WEB_FMS_DOCUMENT = "buyInsuranceWeb";
